<template>
  <div id="areamap-add-update">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="row">
          <div class="col-md-12">
            <div class="card" style="margin-bottom: 9px">
              <div class="card-body">
                <div class="card-title d-flex justify-content-center">
                  <h5 class="font-weight-semibold">{{$t('share_announcement.preview')}}</h5>
                </div>
                <input
                  autocomplete="false"
                  name="hidden"
                  type="text"
                  style="display: none"
                />

                <div class="row justify-content-center">
                  <div class="col-lg-9 col-md-10 col-sm-12 col-xs-12 pb-2">
                    <div class="post-item">
                      <div
                        class="post-header"
                        style="
                          display: flex;
                          flex-direction: row;
                          align-items: center;
                          padding: 5px 10px;
                          border: 1px solid whitesmoke;
                          border-radius: 6px;
                        "
                      >
                        <img
                          :src="$store.getters.currentEvent.logo"
                          style="
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            margin: 0px 10px;
                            background-color: whitesmoke;
                          "
                        />
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                            flex: 1 1 0%;
                            line-height: 15px;
                          "
                        >
                          <span style="font-weight: bold; color: #111111">
                            {{ $store.getters.currentEvent.title }}
                          </span>
                          <span style="color: grey">{{ $t('share_announcement.soon')}}</span>
                        </div>
                        <span>
                          <i
                            class="fa fa-bullhorn"
                            aria-describedby="el-popover-7753"
                            tabindex="0"
                            style="color: grey; font-size: 17px"
                          ></i
                        ></span>
                      </div>
                      <div class="post-content">
                        <p
                          class="content"
                          style="
                            margin: 0px;
                            padding: 5px 10px;
                            margin: 10px 0px;
                          "
                        >
                          {{ form.title }}
                        </p>
                        <div class="post-image">
                          <el-upload
                            class="avatar-uploader upload-demo"
                            :action="
                              axios.defaults.baseURL +
                              'event/uploadImage?uploadType=post&language='+$i18n.locale
                            "
                            :headers="{
                              Authorization:
                                axios.defaults.headers['Authorization'],
                            }"
                            :show-file-list="false"
                            :on-success="logoSuccess"
                            :on-remove="handleRemove"
                            :on-preview="handlePreview"
                            :before-remove="beforeRemove"
                          >
                            <img
                              v-if="form.image"
                              :src="form.image"
                              class="avatar bg-cover"
                              width="100%"
                            />
                            <div slot="file" slot-scope="{ file }">
                              <span
                                v-if="!disabled"
                                class="el-upload-list__item-delete"
                                @click="handleRemove(file)"
                              >
                                <i class="fas fa-trash"></i>
                              </span>
                            </div>

                            <i class="fas fa-plus avatar-uploader-icon"></i>
                            <div class="el-upload__text">
                              {{ $t("event.components.moderation.social.pic") }}
                            </div>
                          </el-upload>
                        </div>
                      </div>
                      <div class="post-footer" style="padding-bottom: 5px">
                        <span
                          style="
                            margin-left: 10px;
                            color: #333;
                            margin-right: 15px;
                          "
                        >
                          <i class="fa fa-heart"></i>
                          0 {{ $t("event.variables.like") }}
                        </span>
                        <span
                          style="
                            margin-left: 10px;
                            color: #333;
                            margin-right: 15px;
                          "
                        >
                          <i class="fa fa-comment"></i>
                          0 {{ $t("event.variables.comment") }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12 mb-2">
                    <div class="announcement" style="margin-top: 15px">
                      <el-input
                        :clearable="true"
                        type="text"
                        v-model="form.title"
                        :class="$inputError('title', validationErrors)"
                        :placeholder="$t('share_announcement.text')"
                      >
                        <el-button slot="prepend" class="fas fa-plus">
                          <el-upload
                            class="avatar-uploader uploader"
                            :onProgress="logoProgress"
                            :action="
                              axios.defaults.baseURL +
                              'event/uploadImage?uploadType=post&language='+$i18n.locale
                            "
                            :headers="{
                              Authorization:
                                axios.defaults.headers['Authorization'],
                            }"
                            :show-file-list="false"
                            :on-success="logoSuccess"
                          >
                          </el-upload>
                        </el-button>
                      </el-input>
                    </div>
                  </div>
                </div>

                <div
                  class="col-md-12"
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0;
                  "
                >
                  <div v-if="form.id != null">
                    <el-popconfirm
                      @confirm="deleteItem"
                      :confirmButtonText="$t('event.variables.yes')"
                      :cancelButtonText="$t('event.buttons.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('event.textbox.toDelete')"
                    >
                      <el-button
                        slot="reference"
                        type="danger"
                        icon="fas fa-trash"
                        >{{ $t("event.table.delete") }}</el-button
                      >
                    </el-popconfirm>
                  </div>
                  <div
                    class="text-right"
                    style="
                      display: flex;
                      flex: 1;
                      align-items: center;
                      justify-content: flex-end;
                    "
                  >
                    <el-button-group>
                      <el-button
                        type="warning"
                        @click="
                          $emit('closeMe');
                          showInfo = false;
                          handleRemove();
                        "
                        >{{ $t("event.buttons.close") }}</el-button
                      >
                      <el-button type="success" @click="save">{{
                        $t("event.buttons.save")
                      }}</el-button>
                    </el-button-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="form.id != null"
      @click="showInfo = !showInfo"
      style="
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 10px 0px;
      "
    >
      <i :class="!showInfo ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>
    <transition name="slide-fade">
      <ItemInfo :data="form" v-if="showInfo" />
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";

export default {
  components: { ItemInfo },
  name: "PostAddUpdate",
  props: ["data"],
  data() {
    return {
      form: {
        id: null,
        title: null,
        image: null,
      },
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
     
    };
  },

  methods: {
    handleRemove(file, form) {
      this.form.image = null;
    },
    handlePreview(file) {},
    beforeRemove(file, fileList) {
      return this.$confirm(`Cancel ?`);
    },
    deleteItem() {
      var index = this.$store.state.social.items.findIndex(
        (k) => k.id == this.form.id
      );
      if (index != -1) {
        this.$emit("deleteMe", index);
        this.$emit("closeMe");
      }
    },
    save() {
      this.validationErrors = [];
      axios.post("post/addorupdate", this.form).then((res) => {
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          if (this.form.id == null) {
            this.$emit("itemAdded");
            this.form = {
              id: null,
              title: null,
              image: null,
              orderNO: this.form.orderNO,
            };
          } else {
            this.$emit("itemUpdated", JSON.parse(JSON.stringify(this.form)));
            if (this.showInfo) {
              this.showInfo = false;
              setTimeout(() => {
                this.showInfo = true;
              }, 350);
            }
          }
        }
      });
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data;
      }
    },
   /*  debounceSearch(event) {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.form.title = event.target.value
      }, 600)
    } */
  },
  watch: {
    data: function (newVal) {
      this.showInfo = false;
      if (newVal != undefined && newVal != null) {
        this.form = this.data;
        this.validationErrors = [];
      } else {
        this.form = {
          id: null,
          title: null,
          image: null,
          orderNO: 1,
        };
      }
    },
  },
  
  created() {
    if (this.data != undefined && this.data != null) {
      this.form = this.data;
    }
  },
};
</script>

<style scoped>
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar-uploader {
  height: inherit;
  display: flex;
  justify-content: center;
}

.post-image {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  justify-content: center;
  height: 150px;
  width: calc(100% - 20px) !important;
  margin: auto 10px 10px;
}

.avatar-uploader-icon {
  height: 1rem;
}

.avatar-uploader.uploader {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  border: none;
  cursor: pointer;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/PostAddUpdate.vue